import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { SpecialtiesService } from 'src/app/cms/specialties/specialties.service';
import { flatMap, first } from 'rxjs/operators';
import { GroupService } from '../group/group.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpecialtiesPickerResolve implements Resolve<any> {

  constructor(
    private ss: SpecialtiesService,
    private gs: GroupService
  ) { }

  resolve(route: ActivatedRouteSnapshot){
    return this.gs.getGroup().pipe(
      first(),
      flatMap(group => {
        let params = {ac_group: group, limit: 999}
        return this.ss.updateSpecialtiesPicker(params)
      })
    )
  }
}
